module.exports = __webpack_public_path__ + "static/media/Board_4@2x.cf880310.png";